import Rollbar from 'rollbar';

// Public browser token (safe to ship to the client).
export const ROLLBAR_CLIENT_TOKEN = '4109e8dfb24f411c815d4c8393d33a4c';

const rollbarConfig: Rollbar.Configuration = {
  accessToken: ROLLBAR_CLIENT_TOKEN,
  environment: process.env.NODE_ENV,
  enabled: !!process.env.NEXT_PUBLIC_CI_COMMIT_SHORT_SHA,
  captureUncaught: true,
  captureUnhandledRejections: true,
  // Piwik PRO throws this when a visitor's tracker blocker (extension) or
  // Firefox Enhanced Tracking Protection blocks its analytics request. Not
  // actionable and not our bug, so keep it out of Rollbar.
  ignoredMessages: ['request blocked by the browser'],
  version: process.env.NEXT_PUBLIC_CI_COMMIT_SHORT_SHA,
  code_version: process.env.NEXT_PUBLIC_CI_COMMIT_SHORT_SHA,
  nodeSourceMaps: true,
  autoInstrument: {
    // CSP violations are reported by our own securitypolicyviolation listener
    // (see RollbarInit) instead of Rollbar's built-in capture, because the
    // built-in hardcodes its fields and omits `sample` (the offending code) and
    // `sourceFile`. Keep this false to avoid duplicate items.
    contentSecurityPolicy: false,
  },
  payload: {
    client: {
      javascript: {
        source_map_enabled: true,
        guess_uncaught_frames: true,
      },
    },
  },
};

let instance: Rollbar | null = null;

/**
 * Returns the singleton browser Rollbar client, creating it on first use.
 * Returns null during SSR (no `window`), so it's safe to call from anywhere.
 * Constructing it installs captureUncaught / captureUnhandledRejections and the
 * CSP autoInstrument listener, so call it early (see RollbarInit in the layout).
 */
export function getRollbar(): Rollbar | null {
  if (typeof window === 'undefined') return null;
  if (!instance) instance = new Rollbar(rollbarConfig);
  return instance;
}
